module.exports = __webpack_public_path__ + "static/media/Cardo-Regular.d88cc3a6.eot";